module.exports = __webpack_public_path__ + "static/media/Light-(Sidebar)-Dark-Layout.5de55148.png";